var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.33341 7.33337H5.33341M6.66675 10H5.33341M10.6667 4.66671H5.33341M13.3334 4.53337V11.4667C13.3334 12.5868 13.3334 13.1469 13.1154 13.5747C12.9237 13.951 12.6177 14.257 12.2414 14.4487C11.8136 14.6667 11.2535 14.6667 10.1334 14.6667H5.86675C4.74664 14.6667 4.18659 14.6667 3.75877 14.4487C3.38244 14.257 3.07648 13.951 2.88473 13.5747C2.66675 13.1469 2.66675 12.5868 2.66675 11.4667V4.53337C2.66675 3.41327 2.66675 2.85322 2.88473 2.42539C3.07648 2.04907 3.38244 1.74311 3.75877 1.55136C4.18659 1.33337 4.74664 1.33337 5.86675 1.33337H10.1334C11.2535 1.33337 11.8136 1.33337 12.2414 1.55136C12.6177 1.74311 12.9237 2.04907 13.1154 2.42539C13.3334 2.85322 13.3334 3.41327 13.3334 4.53337Z",
    stroke: "#A6A9B2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendTemplateIcon);
export default __webpack_public_path__ + "static/media/sendTemplate_icon.01a67921d22080cb6e817407c609e5ef.svg";
export { ForwardRef as ReactComponent };